import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { numericInputOnly, validateAlphanumeric } from "../CrackersUtil";
import { event } from "jquery";

function TextInput({caption, value, onChange, validation, info, onFocusCaption, validator, isMultiLine, type, 
    isNumericField, isPasswordField, readOnly, styles, onChangeParams, isAlphanumeric = false, lowerCaseOnly = false}) {
    const [fieldCaption, setFieldCaption] = useState(caption);
    const inputRef = useRef(null);

    if(!type) {
        type = 'text';
    }

    if(readOnly == null || readOnly === undefined) {
        readOnly = false;
    }

    if(!isNumericField) {
        isNumericField = false;
    }

    const fieldOnBlur = (event) => {
        const value = event.target.value;
        if(!value || value.trim() === '') {
            setFieldCaption(caption);
        }
        if(validator) {
            validator(value);
        }
    }

    const handleKeyDown = (event) => {
        if(isNumericField) {
            numericInputOnly(event);
            return;
        }

        if(isAlphanumeric) {
            validateAlphanumeric(event);
        }
        
        // if(isPasswordField) {
        //     return;
        // }
    }

    const handleKeyUp = (event) => {
        if(lowerCaseOnly) {
            event.target.value = event.target.value.toLowerCase();
        }
    }

    const handleFocus = (event) => {
        setFieldCaption(onFocusCaption);
        if (inputRef.current && !isMultiLine) {
            if(event.target.value && event.target.value !== "") {
                inputRef.current.select();
            }
        }
    }

    return(
        <Form.Group className="form-floating" style={styles}>
            <Form.Control style={{height : isMultiLine ? '100px' : ''}}
                ref={inputRef}
                type={type}
                as={isMultiLine ? 'textarea' : 'input'}
                value={value}
                onFocus={handleFocus}
                onKeyDown={(e) => handleKeyDown(e)}
                onKeyUp={(e) => handleKeyUp(e)}
                onChange={(e) => onchange ? onChange(e.target.value, onChangeParams) : onChange(e.target.value)}
                onBlur={fieldOnBlur}
                placeholder=""
                readOnly={readOnly}
                disabled={readOnly}
                className={`form-control ${validation.reason ? 'is-invalid' : ''}`
            }
            />
            <Form.Label>{fieldCaption}</Form.Label>
            <Form.Control.Feedback type="invalid">
                {validation.reason}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
                {info}
            </Form.Text>
        </Form.Group>
    );
}

export default TextInput;